export function parseDateString(datestring) {
    if(!datestring){
        return new Date();
    }
    const tstampsyntax = [
        /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/,
        // YYYY-MM-DD HH:ii:SS  (DATETIME)
        /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/,
        // YYYY-MM-DD HH:ii  (DATETIME)
        /^(\d{4})-(\d{2})-(\d{2})$/,
        // YYYY-MM-DD (DATE)
        /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/,
        // YYYYMMDDHHIISS (TIMESTAMP)
        /^(\d{1,2})[-.,: ](\d{1,2})[-.,: ](\d{2,4})[-.,: ](\d{1,2})[-.,: ](\d{1,2})[-.,: ](\d{1,2})$/,
        // TT,MM,YYYY,HH,mm
        /^(\d{1,2})[-.,: ](\d{1,2})[-.,: ](\d{2,4})[-.,: ](\d{1,2})[-.,: ](\d{1,2})$/,
        // TT,MM,YYYY,HH,mm
        /^(\d{1,2})[-.,: ](\d{1,2})[-.,: ](\d{2,4})$/,
        // D,M,YY oder DD,MM,YYYY
        /^(\d{2})(\d{2})(\d{2,4})$/,
        // TTMMYY oder TTMMYYYY
        /^(\d{4})-(\d{2})-(\d{2})[\s*]?[A-Za-z]?(\d{2}):(\d{2}):(\d{2})(.*)$/
        //YYYY-MM-DD[A-Z]HH:ii:SS 2012-04-03T10:22:23+02:00
    ];
    const tstampvalue = ['123456', '12345', '123', '123456', '321456', '32145', '321', '321', '123456'];
    let result = new Date();
    tstampsyntax.every((regex, index) => {
            const matches = datestring.match(regex);
            if(matches) {
                let dateparts = [];
                for(let i = 0; i < tstampvalue[index].length; i++) {
                    dateparts[tstampvalue[index].substring(i, i + 1)] = parseInt(matches[(i + 1)]);
                }
                if(dateparts[1] < 70) {
                    dateparts[1] += 2000;
                }
                if(dateparts[1] < 100) {
                    dateparts[1] += 1900;
                }
                dateparts[1] = dateparts[1] ?? 0;
                dateparts[2] = dateparts[2] ?? 0;
                dateparts[3] = dateparts[3] ?? 0;
                dateparts[4] = dateparts[4] ?? 0;
                dateparts[5] = dateparts[5] ?? 0;
                dateparts[6] = dateparts[6] ?? 0;
                result = new Date(dateparts[1], dateparts[2] - 1, dateparts[3], dateparts[4], dateparts[5], dateparts[6]);
                return false;
            }
            return true;
        }
    )
    return result;
}

/*
Format  Output      Description
------  ----------  --------------------------------------------------------------
x  d      10         Day of the month, 2 digits with leading zeros
   D      Wed        A textual representation of a day, three letters
   j      10         Day of the month without leading zeros
   l      Wednesday  A full textual representation of the day of the week
   S      th         English ordinal day of month suffix, 2 chars (use with j)
   w      3          Numeric representation of the day of the week
   z      9          The julian date, or day of the year (0-365)
   W      01         ISO-8601 2-digit week number of year, weeks starting on Monday (00-52)
   F      January    A full textual representation of the month
   m      01         Numeric representation of a month, with leading zeros
   M      Jan        Month name abbreviation, three letters
   n      1          Numeric representation of a month, without leading zeros
   t      31         Number of days in the given month
   L      0          Whether it's a leap year (1 if it is a leap year, else 0)
   Y      2007       A full numeric representation of a year, 4 digits
   y      07         A two digit representation of a year
   a      pm         Lowercase Ante meridiem and Post meridiem
   A      PM         Uppercase Ante meridiem and Post meridiem
   g      3          12-hour format of an hour without leading zeros
   G      15         24-hour format of an hour without leading zeros
   h      03         12-hour format of an hour with leading zeros
   H      15         24-hour format of an hour with leading zeros
   i      05         Minutes with leading zeros
   s      01         Seconds, with leading zeros
   O      -0600      Difference to Greenwich time (GMT) in hours
   T      CST        Timezone setting of the machine running the code
   Z      -21600     Timezone offset in seconds (negative if west of UTC, positive if east)
 */
const dateReplacements = {
    'd' : function(dateString, replacemnt) {
        let day = this.getDate();
        day = day < 10 ? '0' + day : String(day);
        dateString = dateString.replace(replacemnt, day);
        return dateString;
    },
    'D' : function(dateString, replacemnt) {
        return dateString;
    },
    'j' : function(dateString, replacemnt) {
        return dateString;
    },
    'l' : function(dateString, replacemnt) {
        return dateString;
    },
    'S' : function(dateString, replacemnt) {
        return dateString;
    },
    'w' : function(dateString, replacemnt) {
        return dateString;
    },
    'z' : function(dateString, replacemnt) {
        return dateString;
    },
    'W' : function(dateString, replacemnt) {
        return dateString;
    },
    'F' : function(dateString, replacemnt) {
        return dateString;
    },
    'm' : function(dateString, replacemnt) {
        let month = this.getMonth() + 1;
        month = month < 10 ? '0' + month : String(month);
        dateString = dateString.replace(replacemnt, month);
        return dateString;
    },
    'M' : function(dateString, replacemnt) {
        return dateString;
    },
    'n' : function(dateString, replacemnt) {
        return dateString;
    },
    't' : function(dateString, replacemnt) {
        return dateString;
    },
    'L' : function(dateString, replacemnt) {
        return dateString;
    },
    'Y' : function(dateString, replacemnt) {
        dateString = dateString.replace(replacemnt, this.getFullYear())
        return dateString;
    },
    'y' : function(dateString, replacemnt) {
        return dateString;
    },
    'a' : function(dateString, replacemnt) {
        return dateString;
    },
    'A' : function(dateString, replacemnt) {
        return dateString;
    },
    'g' : function(dateString, replacemnt) {
        return dateString;
    },
    'G' : function(dateString, replacemnt) {
        return dateString;
    },
    'h' : function(dateString, replacemnt) {
        return dateString;
    },
    'H' : function(dateString, replacemnt) {
        let hours = this.getHours();
        hours = hours < 10 ? '0' + hours : String(hours);
        dateString = dateString.replace(replacemnt, hours);
        return dateString;
    },
    'i' : function(dateString, replacemnt) {
        let minutes = this.getMinutes();
        minutes = minutes < 10 ? '0' + minutes : String(minutes);
        dateString = dateString.replace(replacemnt, minutes);
        return dateString;
    },
    's' : function(dateString, replacemnt) {
        let seconds = this.getSeconds();
        seconds = seconds < 10 ? '0' + seconds : String(seconds);
        dateString = dateString.replace(replacemnt, seconds);
        return dateString;
    },
    'O' : function(dateString, replacemnt) {
        return dateString;
    },
    'T' : function(dateString, replacemnt) {
        return dateString;
    },
    'Z' : function(dateString, replacemnt) {
        return dateString;
    },
};
export function format(date) {
    if(isNaN(this)) {
        return '';
    }
    for (const [replacement, fnc] of Object.entries(dateReplacements)) {
        date = fnc.call(this, date, replacement);
    }
    return date;
}